module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.7342/images/homepage/corner-blobs.png"